function passwordValidate(pas) {
  if (!pas || !pas.length || pas.length === 0) {
    return { isValid: false, errorMsg: 'Please enter a password.' }
  }
  if (pas.length < 8) {
    return { isValid: false, errorMsg: 'Password must be a minimum of 8 characters.' }
  }

  const containsLetters = new RegExp('[A-Za-z]+');
  if (!containsLetters.exec(pas)) {
    return { isValid: false, errorMsg: 'Password must contain at least one letter.' }
  }

  const containsNumbers = new RegExp('[0-9]+'); // Numbers - allowed and required. Special characters - allowed but don't require.
  if (!containsNumbers.exec(pas)) {
    return { isValid: false, errorMsg: 'Password must contain at least one number.' }
  }
  return { isValid: true, errorMsg: null };
}
function passwordRequiredValidation(pas) {
  if (!pas || !pas.length || pas.length === 0) {
    return { isValid: false, errorMsg: 'Please enter a password.' }
  }
  return { isValid: true, errorMsg: null };
}

function confirmPasswordValidate(confirmPassword, mainPassword) {
  const vRes = passwordValidate(confirmPassword);
  if (vRes.isValid) {
    if (confirmPassword !== mainPassword) {
      return { isValid: false, errorMsg: "Passwords do not match." };
    }
    return { isValid: true, errorMsg: null };
  }
  // have validation error
  return { isValid: vRes.isValid, errorMsg: vRes.errorMsg };
}

module.exports = {
  passwordValidate: passwordValidate,
  confirmPasswordValidate: confirmPasswordValidate,
  passwordRequiredValidation: passwordRequiredValidation
};